import { render, staticRenderFns } from "./base_xml_viewer.vue?vue&type=template&id=c036b86a&scoped=true&"
import script from "./base_xml_viewer.vue?vue&type=script&lang=js&"
export * from "./base_xml_viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c036b86a",
  null
  
)

export default component.exports